export default __webpack_public_path__ + "static/media/ic-dl-lecture-notes.3c165d71.svg";